import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "./../../api/apiCaller";

export const GET_SMS_GATEWAY = "GET_SMS_GATEWAY";
export const GET_SMS_GATEWAY_SUCCESS = "GET_SMS_GATEWAY_SUCCESS";
export const GET_SMS_GATEWAY_ERROR = "GET_SMS_GATEWAY_ERROR";

export const COUNT_LIST_SMS_GATEWAY = "COUNT_LIST_SMS_GATEWAY";
export const COUNT_LIST_SMS_GATEWAY_SUCCESS = "COUNT_LIST_SMS_GATEWAY_SUCCESS";
export const COUNT_LIST_SMS_GATEWAY_ERROR = "COUNT_LIST_SMS_GATEWAY_ERROR";

export const CREATE_SMS_GATEWAY = "CREATE_SMS_GATEWAY";
export const CREATE_SMS_GATEWAY_SUCCESS = "CREATE_SMS_GATEWAY_SUCCESS";
export const CREATE_SMS_GATEWAY_ERROR = "CREATE_SMS_GATEWAY_ERROR";

export const DELETE_SMS_GATEWAY = "DELETE_SMS_GATEWAY";
export const DELETE_SMS_GATEWAY_SUCCESS = "DELETE_SMS_GATEWAY_SUCCESS";
export const DELETE_SMS_GATEWAY_ERROR = "DELETE_SMS_GATEWAY_ERROR";

export const EDIT_SMS_GATEWAY = "EDIT_SMS_GATEWAY";
export const EDIT_SMS_GATEWAY_SUCCESS = "EDIT_SMS_GATEWAY_SUCCESS";
export const EDIT_SMS_GATEWAY_ERROR = "EDIT_SMS_GATEWAY_ERROR";

/**
 * Reducer
 */

const initialState = {};

export const smsReducer = (state = initialState, action) => {
  switch (action.type) {
    //gateway
    case COUNT_LIST_SMS_GATEWAY:
      return {
        ...state,
      };
    case COUNT_LIST_SMS_GATEWAY_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_LIST_SMS_GATEWAY_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case GET_SMS_GATEWAY:
      return {
        ...state,
      };
    case GET_SMS_GATEWAY_SUCCESS:
      return {
        ...state,
        gateway: action.payload,
      };
    case GET_SMS_GATEWAY_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case CREATE_SMS_GATEWAY:
      return {
        ...state,
      };
    case CREATE_SMS_GATEWAY_SUCCESS:
      return {
        ...state,
        gateway: action.payload,
      };
    case CREATE_SMS_GATEWAY_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case EDIT_SMS_GATEWAY:
      return {
        ...state,
      };
    case EDIT_SMS_GATEWAY_SUCCESS: {
      const listGatewaysResult =
        typeof state.gateway === "object"
          ? Object.keys(state.gateway).map((key) => state.gateway[key])
          : state.gateway;
      const newData = listGatewaysResult.map((i) => {
        if (i.id === action.data.id) {
          i.id = action.data.id;
          i.providerId = action.data.providerId;
          i.connection.protocol = action.data.connection.protocol;
          i.connection.request.host = action.data.connection.request.host;
          i.connection.request.path = action.data.connection.request.path;
          i.connection.request.method = action.data.connection.request.method;
          i.connection.request.header.authorization =
            action.data.connection.request.header.authorization;
          i.connection.request.header.contentType =
            action.data.connection.request.header.contentType;
          i.connection.request.body.sender =
            action.data.connection.request.body.sender;
          i.connection.request.body.phonenumber =
            action.data.connection.request.body.phonenumber;
          i.note = action.data.note;
          i.acti = action.data.acti;
        }
        return i;
      });
      return {
        ...state,
        newData,
      };
    }
    case EDIT_SMS_GATEWAY_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case DELETE_SMS_GATEWAY:
      return {
        ...state,
      };
    case DELETE_SMS_GATEWAY_SUCCESS: {
      const newData = state.gateway.filter((i) => i.id !== action.data.id);
      return {
        ...state,
        newData,
      };
    }
    case DELETE_SMS_GATEWAY_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */

//GATEWAY
export const getSmsGateway = (order, limit, skip, where) => ({
  type: GET_SMS_GATEWAY,
  data: {
    order,
    limit,
    skip,
    ...where,
  },
});
export const countSmsGateway = (where) => ({
  type: COUNT_LIST_SMS_GATEWAY,
  data: {
    where,
  },
});

export const createSmsGateway = (id, providerId, note, connection) => ({
  type: CREATE_SMS_GATEWAY,
  data: {
    id,
    providerId,
    note,
    ...connection,
  },
});

export const deleteSmsGateway = (id) => ({
  type: DELETE_SMS_GATEWAY,
  data: {
    id,
  },
});

export const editSmsGateway = (id, name, note) => ({
  type: EDIT_SMS_GATEWAY,
  data: {
    id,
    name,
    note,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getSmsGateway,
      countSmsGateway,
      createSmsGateway,
      deleteSmsGateway,
      editSmsGateway,
    },
    dispatch
  );
};

/**
 * Apis
 */

//GATEWAY
const getSmsGatewayApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/messaging/sms-gateway", {
    order,
    limit,
    skip,
    where,
  });
};
const countSmsGatewayApi = (where) => {
  return apiCaller.getLogs("/messaging/sms-gateway/count", { where });
};
const createSmsGatewayApi = (id, name, note) => {
  return apiCaller.post("/messaging/sms-gateway", { id, name, note });
};
const editSmsGatewayApi = (id, name, note) => {
  return apiCaller.put(`/messaging/sms-gateway/${id}`, { name, note });
};
const deleteSmsGatewayApi = (id) => {
  return apiCaller.del(`/messaging/sms-gateway/${id}`);
};

/**
 * sagas
 */

//gateway
export const getSmsGatewayFlow = function* () {
  while (true) {
    const action = yield take(GET_SMS_GATEWAY);
    try {
      const res = yield call(
        getSmsGatewayApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({
        type: GET_SMS_GATEWAY_SUCCESS,
        payload: { ...res.data },
        data: action.data,
      });
    } catch (error) {
      yield put({ type: GET_SMS_GATEWAY_ERROR, error });
    }
  }
};

export const countSmsGatewayFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_SMS_GATEWAY);
    try {
      const res = yield call(countSmsGatewayApi, action.data.where);
      yield put({
        type: COUNT_LIST_SMS_GATEWAY_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_SMS_GATEWAY_ERROR, error });
    }
  }
};

export const createSmsGatewayFlow = function* () {
  while (true) {
    const action = yield take(CREATE_SMS_GATEWAY);
    try {
      const res = yield call(
        createSmsGatewayApi,
        action.data.id,
        action.data.name,
        action.data.note
      );
      yield put({
        type: CREATE_SMS_GATEWAY_SUCCESS,
        payload: { ...res.data },
        data: action.data,
      });
    } catch (error) {
      yield put({ type: CREATE_SMS_GATEWAY_ERROR, error });
    }
  }
};

export const deleteSmsGatewayFlow = function* () {
  while (true) {
    const action = yield take(DELETE_SMS_GATEWAY);
    try {
      const res = yield call(deleteSmsGatewayApi, action.data.id);
      yield put({
        type: DELETE_SMS_GATEWAY_SUCCESS,
        payload: { ...res.data },
        data: action.data,
      });
    } catch (error) {
      yield put({ type: DELETE_SMS_GATEWAY_ERROR, error });
    }
  }
};

export const editSmsGatewayFlow = function* () {
  while (true) {
    const action = yield take(EDIT_SMS_GATEWAY);
    try {
      const res = yield call(
        editSmsGatewayApi,
        action.data.id,
        action.data.name,
        action.data.note
      );
      yield put({
        type: EDIT_SMS_GATEWAY_SUCCESS,
        payload: { ...res.data },
        data: action.data,
      });
    } catch (error) {
      yield put({ type: EDIT_SMS_GATEWAY_ERROR, error });
    }
  }
};
